import { render, staticRenderFns } from "./DashboardComponent.vue?vue&type=template&id=b337d6a8&scoped=true"
import script from "./DashboardComponent.js?vue&type=script&lang=js&external"
export * from "./DashboardComponent.js?vue&type=script&lang=js&external"
import style0 from "./DashboardComponent.vue?vue&type=style&index=0&id=b337d6a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b337d6a8",
  null
  
)

export default component.exports